import CompanyCard from "./CompanyCard"

export { ShimmerCompanyCard } from "./ShimmerCompanyCard"
export { SecondaryCompanyCard } from "./SecondaryCompanyCard"

export default CompanyCard;